import * as ActionTypes from './index';
import {actionCreator} from "../helpers/functions";

export const getSpecialOffers = actionCreator(ActionTypes.GET_SPECIAL_OFFERS);
export const getSpecialOffersSuccess = actionCreator(ActionTypes.GET_SPECIAL_OFFERS_SUCCESS);
export const getSpecialOffersFailed = actionCreator(ActionTypes.GET_SPECIAL_OFFERS_FAILED);
export const countSpecialOffers = actionCreator(ActionTypes.COUNT_SPECIAL_OFFERS);
export const countSpecialOffersSuccess = actionCreator(ActionTypes.COUNT_SPECIAL_OFFERS_SUCCESS);
export const countSpecialOffersFailed = actionCreator(ActionTypes.COUNT_SPECIAL_OFFERS_FAILED);
export const changeSpecialOfferPreferences = actionCreator(ActionTypes.CHANGE_SPECIAL_OFFERS_PREFERENCES);
export const changeSpecialOffersOrder = actionCreator(ActionTypes.CHANGE_SPECIAL_OFFERS_ORDER);
export const createSpecialOffer = actionCreator(ActionTypes.CREATE_SPECIAL_OFFER);
export const createSpecialOfferSuccess = actionCreator(ActionTypes.CREATE_SPECIAL_OFFER_SUCCESS);
export const createSpecialOfferFailed = actionCreator(ActionTypes.CREATE_SPECIAL_OFFER_FAILED);
export const deleteSpecialOffer = actionCreator(ActionTypes.DELETE_SPECIAL_OFFER);
export const editSpecialOffer = actionCreator(ActionTypes.EDIT_SPECIAL_OFFER);
export const editSpecialOfferSuccess = actionCreator(ActionTypes.EDIT_SPECIAL_OFFER_SUCCESS);
export const editSpecialOfferFailed = actionCreator(ActionTypes.EDIT_SPECIAL_OFFER_FAILED);
export const editSpecialOfferField = actionCreator(ActionTypes.EDIT_SPECIAL_OFFER_FIELD);
export const copySpecialOfferForEdit = actionCreator(ActionTypes.COPY_SPECIAL_OFFER_FOR_EDIT);
export const clearProductSpecialOfferDeleteErrorMessage = actionCreator(ActionTypes.CLEAR_SPECIAL_OFFER_DELETE_ERROR_MESSAGE);
export const deleteSpecialOfferSuccess = actionCreator(ActionTypes.DELETE_SPECIAL_OFFER_SUCCESS);
export const deleteSpecialOfferFailed = actionCreator(ActionTypes.DELETE_SPECIAL_OFFER_FAILED);
export const clearSpecialOffersForm = actionCreator(ActionTypes.CLEAR_SPECIAL_OFFERS_FORM);
export const clearTempUploadedSpecialOffer = actionCreator(ActionTypes.CLEAR_TEMP_UPLOADED_SPECIAL_OFFER);
export const storeTemporarySpecialOfferImage = actionCreator(ActionTypes.STORE_TEMPORARY_SPECIAL_OFFER_IMAGE);



// WEBPACK FOOTER //
// ./src/actions/specialOffers.js